import { FleetMode } from "@/enum/FleetMode"

export interface IFleetIrisConfigBase {	 	
	fleet_type:FleetMode	
	glider_number:number

	//Ajouter par la suitre par le service coté iris
	fleet_company:string
	fleet_name:string

	fleet_state:string|null
	fleet_state_timestamp:string|null

}

export function getDefaultFleetIrisConfigBase({
		fleet_type=FleetMode.FREE,
		glider_number=1,
		fleet_company='',
		fleet_name='',
		fleet_state=null,
		fleet_state_timestamp=null}={}):IFleetIrisConfigBase {
	return {		
		fleet_type,
		glider_number,
		fleet_company,
		fleet_name,
		fleet_state,
		fleet_state_timestamp

	} 
}